import { EcardThemeCard } from './EcardThemeCard';
export default EcardThemeCard;
